import React from "react";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";

function SolutionsFeature() {
  const [activeTab, setActiveTab] = React.useState("tab1");
  return (
    <div className="pricing-2">
      <Container>
        <Row>
          <Col className="mx-auto text-center mt-5" md="6">
            <h3 className="display-3">Private Investigations and Corporate Investigations</h3>
          </Col>
        </Row>
        <Row>
          <Col className="mx-auto text-center mb-3" md="10">
            <p className="font-weight-bold text-default">
              Private Investigations at CrypTegridy focus on a variety of techniques, including surveillance, 
              digital footprinting, and background checks, to gather information discreetly and legally.
              <br></br>
              Corporate Investigations are centered around businesses and corporate entities. Our corporate 
              investigators have a deep understanding of corporate structures, financial systems, and regulatory 
              requirements, enabling them to effectively conduct thorough investigations.
            </p>
            <div className="section-space"></div>
          </Col>
        </Row>
        <div className="space-100"></div>
        <Row>
          <div className="nav-wrapper mx-auto mr-3 mb-3">
            <Nav
              className="nav-pills-info nav-fill flex-column flex-md-row"
              pills
              role="tablist"
            >
              <NavItem>
                <Button
                  className={
                    "mb-sm-3 mb-md-0 text-info bg-default btn-tooltip " +
                    (activeTab === "tab1" ? "active" : "")
                  }
                  href="#"
                  id="tooltip734051587"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("tab1");
                  }}
                >
                  Private
                </Button>
                <UncontrolledTooltip
                  innerClassName="bg-info text-default"
                  delay={0}
                  placement="top"
                  target="tooltip734051587"
                >
                  Private Investigations
                </UncontrolledTooltip>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    "mb-sm-3 mb-md-0 text-info bg-default btn-tooltip " +
                    (activeTab === "tab2" ? "active" : "")
                  }
                  href="#"
                  id="tooltip734052465"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("tab2");
                  }}
                >
                  Corporate
                </NavLink>
                <UncontrolledTooltip
                  innerClassName="bg-info text-default"
                  delay={0}
                  placement="top"
                  target="tooltip734052465"
                >
                  Corporate Investigations
                </UncontrolledTooltip>
              </NavItem>
            </Nav>
          </div>
        </Row>
        <Col lg="12">
          <TabContent className="tab-space" activeTab={activeTab}>
            <TabPane tabId="tab1">
              <Row>
                <Col md="4">
                  <Card className="card-pricing bg-default card-background" data-background="image">
                    <CardBody>
                      <CardTitle className="text-info h5" tag="h1">
                        Background Checks
                      </CardTitle>
                      <ul>
                        <li>
                          <b>Reputational Analysis</b>
                        </li>
                        <li>
                          <b>Identity Verification</b>
                        </li>
                        <li>
                          <b>Online Activity Monitoring</b>
                        </li>
                        <li>
                          <b>Person Locating</b>
                        </li>
                      </ul>
                      <Button
                        className="btn-info text-default mt-3"
                        color="info"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="card-pricing bg-default card-background" data-background="image">
                    <CardBody>
                      <CardTitle className="text-info h5" tag="h1">
                        Surveillance Operations
                      </CardTitle>
                      <ul>
                        <li>
                          <b>Discreet Surveillance</b>
                        </li>
                        <li>
                          <b>Undercover Operations</b>
                        </li>
                        <li>
                          <b>Counterintelligence</b>
                        </li>
                        <li>
                          <b>Risk Assessment</b>
                        </li>
                      </ul>
                      <Button
                        className="btn-info text-default mt-3"
                        color="info"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="card-pricing bg-default card-background" data-background="image">
                    <CardBody>
                      <CardTitle className="text-info h5" tag="h1">
                        Asset Locating
                      </CardTitle>
                      <ul>
                        <li>
                          <b>Fraud Detection</b>
                        </li>
                        <li>
                          <b>Forensic Analysis</b>
                        </li>
                        <li>
                          <b>Digital Footprinting</b>
                        </li>
                        <li>
                          <b>Witness Statements</b>
                        </li>
                      </ul>
                      <Button
                        className="btn-info text-default mt-3"
                        color="info"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="tab2">
              <Row>
                <Col md="4">
                  <Card className="card-pricing bg-default card-background" data-background="image">
                    <CardBody>
                      <CardTitle className="text-info h5" tag="h1">
                        Due Diligence
                      </CardTitle>
                      <ul>
                        <li>
                          <b>Supply Chain Analysis</b>
                        </li>
                        <li>
                          <b>Reputational Risk</b>
                        </li>
                        <li>
                          <b>Risk Profiling</b>
                        </li>
                        <li>
                          <b>Employee Investigations</b>
                        </li>
                      </ul>
                      <Button
                        className="btn-info text-default mt-3"
                        color="info"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="card-pricing bg-default card-background" data-background="image">
                    <CardBody>
                      <CardTitle className="text-info h5" tag="h1">
                        Operational Reports
                      </CardTitle>
                      <ul>
                        <li>
                          <b>Internal Audits</b>
                        </li>
                        <li>
                          <b>Compliance Reports</b>
                        </li>
                        <li>
                          <b>Regulatory Compliance</b>
                        </li>
                        <li>
                          <b>Risk Profiling</b>
                        </li>
                      </ul>
                      <Button
                        className="btn-info text-default mt-3"
                        color="info"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="card-pricing bg-default card-background" data-background="image">
                    <CardBody>
                      <CardTitle className="text-info h5" tag="h1">
                        Crisis Management
                      </CardTitle>
                      <ul>
                        <li>
                          <b>Fraud Detection</b>
                        </li>
                        <li>
                          <b>Corporate Espionage</b>
                        </li>
                        <li>
                          <b>Financial Discrepancies</b>
                        </li>
                        <li>
                          <b>Stakeholder Communication</b>
                        </li>
                      </ul>
                      <Button
                        className="btn-info text-default mt-3"
                        color="info"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Get Started
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Col>
      </Container>
    </div>
  );
}

export default SolutionsFeature;
